import React from 'react';
import { TextField, Tooltip } from '@material-ui/core';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useInputStyles = makeStyles(() => ({
  root: {
    borderRadius: 0
  },
  input: {
    textAlign: 'center',
    padding: '8px'
  }
}));

const InputField = ({ name, TextFieldProps: { ...otherTextFieldProps }, ...props }) => {
  const inputClasses = useInputStyles();

  return (
    <Field name={name} {...props}>
      {({ field, meta }) => {
        const inputField = (
          <TextField
            variant="outlined"
            autoComplete="off"
            fullWidth
            {...field}
            error={meta.touched && Boolean(meta.error)}
            InputProps={{ classes: inputClasses }}
            {...otherTextFieldProps}
          />
        );

        if (meta.touched && meta.error) {
          return (
            <Tooltip title={meta.error} placement="top">
              {inputField}
            </Tooltip>
          );
        }
        return inputField;
      }}
    </Field>
  );
};

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  TextFieldProps: PropTypes.any
};

InputField.defaultProps = {
  TextFieldProps: {}
};

export default InputField;
